"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const merge_1 = __importDefault(require("lodash/merge"));
const clubFilesImporter_1 = require("modules/translation/clubFilesImporter");
const importer_1 = require("modules/translation/importer");
const constants_1 = require("./constants");
class TranslationService {
    constructor() {
        this.getAdminKeys = async (locale) => {
            let adminKeys = {};
            adminKeys = await (0, importer_1.importTranslationFile)(locale);
            adminKeys = this.removeEmptyKeys(adminKeys);
            return adminKeys;
        };
        this.getFilesKeys = async (locale) => {
            let filesKeys = await (0, clubFilesImporter_1.importClubFilesTranslationFile)(locale);
            filesKeys = this.removeEmptyKeys(filesKeys);
            return filesKeys;
        };
        this.getKeys = async (locale) => {
            const supportedLocale = this.getSupportedLocale(locale);
            const [adminKeys, filesKeys] = await Promise.all([
                this.getAdminKeys(supportedLocale),
                this.getFilesKeys(supportedLocale)
            ]);
            return (0, merge_1.default)({}, adminKeys, filesKeys);
        };
    }
    getSupportedLocale(locale) {
        return constants_1.SUPPORTED_LOCALES.includes(locale) ? locale : constants_1.FALLBACK_LOCALE;
    }
    removeEmptyKeys(file) {
        try {
            return JSON.parse(JSON.stringify(file, (_, value) => value || void 0));
        }
        catch (e) {
            return file;
        }
    }
}
exports.default = new TranslationService();
